package com.wintermar.inspection.core.ui.component.datetime

import androidx.compose.runtime.Composable

@Composable
actual fun DateTimePickerModal(
    title: String,
    dateIsoUtc0: String,
    show: Boolean,
    onDismiss: () -> Unit,
    onSave: (String) -> Unit
) {
    DateTimePickerDialog(
        title = title,
        dateIsoUtc0String = dateIsoUtc0,
        show = show,
        onDismiss = onDismiss,
        onSave = onSave
    )
}
